import React, { createContext, useMemo } from 'react'

export const LocaleContext = createContext({
  locale: 'en',
  dir: 'ltr',
  defaultLocale: 'en',
  locales: [],
  translations: {},
  fallbackTranslations: {},
  t: key => key
})

const getNestedValue = (obj, path) => {
  return path
    .split('.')
    .reduce(
      (acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined),
      obj
    )
}

const interpolate = (str, params) => {
  if (!params || typeof str !== 'string') return str
  return Object.entries(params).reduce(
    (result, [key, value]) =>
      result.replace(new RegExp(`\\{${key}\\}`, 'g'), value),
    str
  )
}

export const LocaleProvider = ({
  locale,
  dir,
  defaultLocale,
  locales,
  translations,
  fallbackTranslations = {},
  translationStrings,
  children
}) => {
  const value = useMemo(() => {
    const t = (key, params) => {
      const val = getNestedValue(translationStrings, key)
      if (val === undefined) return key
      return interpolate(val, params)
    }
    return {
      locale,
      dir,
      defaultLocale,
      locales,
      translations,
      fallbackTranslations,
      t
    }
  }, [
    locale,
    dir,
    defaultLocale,
    locales,
    translations,
    fallbackTranslations,
    translationStrings
  ])

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  )
}
